// CustomButton.js
import React from "react";
import { useTranslation } from "react-i18next";
import { ButtonStyled } from "./ButtonStyled";

const CustomButton = ({
  text,
  icon,
  onClick,
  style,
  bgColor,
  color,
  noHover,
}) => {
  const { t } = useTranslation();
  return (
    <ButtonStyled
      bgColor={bgColor}
      onClick={onClick}
      endIcon={icon}
      color={color}
      noHover={noHover}
      style={{ ...style }}>
      {t(text)}
    </ButtonStyled>
  );
};

export default CustomButton;
